import type { NormalizedCacheObject } from '@apollo/client';
import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import ApolloLinkTimeout from 'apollo-link-timeout';

import { graphqlClientId } from '../constants/applicationConstants';

type ApolloHeaders = Record<
    | 'client-id'
    | 'content-type'
    | 'x-user-guid'
    | 'x-z-sid'
    | 'x-z-ssid'
    | 'x-z-login-memento'
    | 'x-caller-id'
    | 'x-caller-version'
    | 'x-z-enable-oauth-conversion'
    | 'x-client-ip',
    string
>;

export const getApolloHeaders = (requestHeaders: Record<string, string>): ApolloHeaders => ({
    'client-id': graphqlClientId,
    'x-caller-id': graphqlClientId,
    'x-caller-version': WEBPACK.GIT_HASH,
    'content-type': 'application/json',
    'x-user-guid': requestHeaders['x-user-guid'] ?? '',
    'x-z-sid': requestHeaders['x-z-sid'] ?? '',
    'x-z-ssid': requestHeaders['x-z-ssid'] ?? '',
    'x-z-login-memento': requestHeaders['x-z-login-memento'] ?? '',
    'x-z-enable-oauth-conversion': 'true',
    'x-client-ip': requestHeaders['x-client-ip'] ?? '',
});

interface ApolloClientProps {
    apolloHeaders: ApolloHeaders;
    uri: string;
    timeout?: number | null;
}

export const createApolloClient = ({
    apolloHeaders,
    uri,
    timeout = null,
}: ApolloClientProps): ApolloClient<NormalizedCacheObject> => {
    if (timeout) {
        const timeoutLink = new ApolloLinkTimeout(timeout);
        const httpLink = createHttpLink({
            uri,
            headers: apolloHeaders,
        });
        const timeoutHttpLink = timeoutLink.concat(httpLink);
        return new ApolloClient({
            cache: new InMemoryCache(),
            link: timeoutHttpLink,
        });
    }

    return new ApolloClient({
        cache: new InMemoryCache(),
        headers: apolloHeaders,
        uri,
    });
};
